import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth-service';
import { Router } from '@angular/router';
import { RequestsWithoutAccesstoken } from '../helpers/bypassRequests';

@Injectable({ providedIn: 'root' })
export class JwtInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);
    private router = inject(Router);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const shouldBypass = RequestsWithoutAccesstoken.some(entry => req.url.includes(entry));
        const token = this.authService.getAuthToken();

        const authReq = (!shouldBypass && token)
            ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            : req;

        return next.handle(authReq).pipe(
            catchError(err => {
                if (err && err.status === 401) {
                    // clear local auth and redirect to login
                    this.authService.clearToken();
                    this.authService.clearUser();
                    localStorage.clear();
                    this.router.navigate(['/login']);
                }
                return throwError(() => err);
            })
        );
    }
}